import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./../api/request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { CommonService } from "../api";

@Injectable({
  providedIn: "root",
})
export class MasterHospitalService {
  constructor(
    private request: Request,
    private http: HttpClient,
    private _commonService: CommonService,
  ) {
  }

  getCountryLists(): Observable<any> {
    let url = URLS.x_a2z_apis.getMastersList;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{slug}", 'country');
    return this.request.getApi(url);
  }

  getMasterX(slug): Observable<any> {
    let url = URLS.x_a2z_apis.getMastersList;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{slug}", slug);
    return this.request.getApi(url);
  }

  getTimezoneX(): Observable<any> {
    let url = URLS.x_a2z_apis.getTimezoneList;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }

  getSpecialityLists(): Observable<any> {
    let url = URLS.x_a2z_apis.getMastersList;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    url = _.replace(url, "{slug}", 'speciality');
    return this.request.getApi(url);
  }

  getTimezoneLists(): Observable<any> {
    let url = URLS.x_a2z_apis.getTimezoneList;
    url = _.replace(url, "{entity}", this._commonService.getEntity());
    return this.request.getApi(url);
  }

  getAutoCompletePatientsList(val,role): Observable<any> {
    let url = URLS.users.getUsersList+'?&searchkey='+val+'&limit=10&role='+role;
    return this.request.getApi(url);
  }

  getAutoCompleteHospitalStaffsList(val): Observable<any> {
    let url = URLS.hospital.getHospitalStaffsFullList+'?activeUsers=active&searchkey='+val;
    return this.request.getApi(url);
  }
}
